




















































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import store from "@/store/store";
import TextInput from "@/components/TextInput.vue";
import { VueEditor } from "vue2-editor";
import DropDownInput from "@/components/DropDownInput.vue";
import SchedulePanel from "@/components/Admin/SchedulePanel.vue";
import Badge from "@/components/html/Badge.vue";
import { jobService } from "@/services/job.service";
import { userService } from "@/services/user.service";
import { categoryService } from "@/services/category.service";
import { pinboardService } from "@/services/pinboard.service";
import { imageService } from "@/services/image.service";
import { Job } from "@/models/job.model";
import { Category } from "@/models/category.model";
import { User } from "@/models/user.model";
import PinBoard from "@/views/PinBoard.vue";
import { Schedule } from "@/models/schedule.model";
import { cardService } from "../../services/card.service";
import { JobCommand, Action } from "@/models/app.model";

import Modal from "@/components/Modal.vue";
import CleanModal from "@/components/CleanModal.vue";
import { toHtml } from "@fortawesome/fontawesome-svg-core";
import Utils from "@/common/utils";
import { setting } from "@/common/settings";
require("@/assets/css/modal.scss");

@Component({
    components: {
        TextInput,
        DropDownInput,
        SchedulePanel,
        VueEditor,
        Modal,
        Badge,
        CleanModal
    },
})
export default class JobModal extends Vue {
    @Prop() private id!: number;
    @Prop() private action!: number;
    // @Prop() private currentPinBoardId!: number;
    @Prop() private pinBoardIsSource!: boolean;
    actionEnum = Action;
    customToolbar = [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["code-block", "link"],
    ];
    setting = setting;
    showContent: boolean = false;
    categories: any = [];
    cards: any[] = [];
    selectedCards: any[] = [];
    pinboards: any = [];
    job: Job = {
        imageIds: [],
        categoryId: -1,
        assignJobTo: [],
        doAble: true,
        dueWarning: false,
        pinBoardId: this.pinBoardIsSource ? this.currentPinBoardId : -1,
        schedule: { scheduleType: 1, repeatWeeks: 1, startDate: new Date() },
        companyId: this.$store.getters["app/companyId"],
    };

    errors: string[] = [];

    async created() {
        this.selectedCards = [];
        this.categories = await categoryService.getAllKeyValue(
            this.$store.getters["app/companyId"]
        );
        this.pinboards = await pinboardService.getAllKeyValue(
            this.$store.getters["app/companyId"]
        );
    }

    async remove() {
        if (
            // @ts-ignore
            await this.$refs.confirm.open(
                "Vill du verkligen ta bort denna ToDo?"
            )
        ) {
            store.dispatch("app/resetErrors");
            this.job.assignJobTo = this.selectedCards.map((c) => c.key);
            if (this.job.id) {
                var result = await jobService.delete(this.job.id);

                if (result) {
                    this.$notify({
                        group: "message",
                        title: "Succe!",
                        text: "Jobb borttaget",
                        duration: 5000,
                        type: "success",
                    });

                    this.$emit("modalEmit", "saved");
                    this.$emit("modalEventEmit", false);
                    this.showContent = false;
                }
            }
        } else {
        }
    }

        imageIdToLoad: number = 0;
    async showImageModal(id: number) {
        this.imageIdToLoad = id;
        //@ts-ignore
        await this.$refs.imageModal.open("");
    }

    close() {
        this.showContent = false;
        this.clearModel();
        // this.$store.dispatch("job/doneEditJob");
        this.$emit("modalEventEmit", false);
    }

    async save() {
        store.dispatch("app/resetErrors");
        this.job.assignJobTo = this.selectedCards.map((c) => c.key);

        let result = await this.$store.dispatch("job/createJob", {
            job: this.job,
            addedFrom: this.pinBoardIsSource ? "pinboard" : "admin",
        });

        if (result) {
            this.job.id = result;
            // has image
            if (this.image.length) {
                await this.addImage(this.job.id!);
            }

            this.$emit("modalEventEmit", false);
            this.$emit("modalEmit", "saved", this.job.id);
            this.job = {};
            if (this.pinBoardIsSource) {
                this.job = { pinBoardId: this.currentPinBoardId };
            }
            this.clearModel();
        }
    }

    async update() {
        store.dispatch("app/resetErrors");
        this.job.assignJobTo = this.selectedCards.map((c) => c.key);
        // has image
        // if (this.image.length) {
        //     await this.addImage(this.job.id!);
        // }

        jobService.update(this.job).then((response) => {
            this.$notify({
                group: "message",
                title: "Succe!",
                text: "Jobb uppdaterad",
                duration: 5000,
                type: "success",
            });
            this.$emit("modalEmit", "saved");
            this.$emit("modalEventEmit", false);
        });

        this.clearModel();
    }

    clearModel() {
        this.image = {};
        this.formData = {};
    }

    async createCopy() {
        let idCopy = this.id;
        this.showContent = false;
        await this.$emit("modalEventEmit", false);
        await this.$store.dispatch("job/editJob", {
            jobId: idCopy,
            action: this.actionEnum.copy,
        });
    }

    async addImage(jobId: number) {
        const imageId = await imageService.createImage(this.formData);
        if (imageId && this.job.id) {
            var result = await imageService.createJobImage({
                jobId: this.job.id,
                imageId: imageId,
            });

            if (result) {
                this.job.imageIds!.push(imageId);
            }
        }
    }

    async deleteImage(id: number) {
        //@ts-ignore
        if (await this.$refs.confirm.open("Vill du ta bort bilden?")) {
            const result = await imageService.delete(id);
            if (result) {
                var index = this.job.imageIds!.findIndex((i) => i == id);
                this.job.imageIds!.splice(index!, 1);
            }
        }
    }

    scheduleEvent(obj: any) {
        // this.job.schedule = obj;
    }

    get jobAction() {
        return this.$store.getters["job/jobAction"];
    }

    get createJobOnCard() {
        return this.$store.getters["job/createJobOnCardId"];
    }
    @Watch("createJobOnCard")
    async createJobOnCardChanged(val: number) {
        if (this.createJobOnCard != undefined) {
            this.selectedCards = [
                {
                    key: this.createJobOnCard,
                    value: this.cards.find((u) => u.key == this.createJobOnCard)
                        .value,
                },
            ];
        }
    }

    @Watch("job.pinBoardId")
    async selectedPinBoardChanged(val: number) {
        if (val != -1 && val) {
            this.cards = await cardService.getAllKeyValueOnPinBoard(val);
        }
        // this.selectedCards = [];
        // this.users = await userService.getAllByPinBoardId(this.job.pinBoardId!);
    }

    @Watch("currentPinBoardId")
    currentPinBoardChanged(val: number) {
        this.job.pinBoardId = val;
    }

    get currentPinBoardId() {
        return this.$store.getters["app/currentPinBoard"].id;
    }

    @Watch("jobAction")
    jobActionChanged(val: any) {
        if (val == 2) {
            this.job.id = undefined;
        }
    }

    @Watch("id")
    async idChanged() {
        store.dispatch("app/resetErrors");
        // this.selectedUser = undefined;
        
        if (this.id != 0 && this.id != -1 && this.id) {
            this.job = await jobService.getDetails(this.id);
            this.cards = await cardService.getAllKeyValueOnPinBoard(
                this.job.pinBoardId!
            );

            if (this.jobAction == 2) {
                console.log(this.job);
                this.job.assignJobTo = [];
                this.job.schedule = {
                    scheduleType: 1,
                    repeatWeeks: 1,
                    startDate: new Date(),
                };
                this.job.id = undefined;
                this.job.category = undefined;
                this.job.scheduleId = undefined;
                this.job.schedule!.id = undefined;
            }

            this.selectedCards = this.job.assignJobTo!.map((cu) => ({
                key: cu,
                value: this.cards.find((u) => u.key == cu).value,
            }));

            // this.job.schedule = await jobService.getScheduleDetails(this.job.scheduleId!);
            // this.selectedCategory = this.job.categoryId;
            // this.selectedPinboard = this.job.pinBoardId;
            // this.selectedUser = this.job.userId;
        } else {
            this.cards = await cardService.getAllKeyValueOnPinBoard(this.currentPinBoardId);

            this.job = {
                imageIds: [],
                categoryId: -1,
                doAble: true,
                dueWarning:false,
                assignJobTo: [],
                pinBoardId: this.pinBoardIsSource ? this.currentPinBoardId : -1,
                schedule: {
                    scheduleType: 1,
                    repeatWeeks: 1,
                    startDate: new Date(),
                },
                companyId: this.$store.getters["app/companyId"],
            };
            if (this.createJobOnCard != undefined) {
                this.selectedCards = [
                    {
                        key: this.createJobOnCard,
                        value: this.cards.find(
                            (u) => u.key == this.createJobOnCard
                        ).value,
                    },
                ];
            } else this.selectedCards = [];
            // this.selectedCategory = this.job.categoryId;
            // this.selectedPinboard = this.job.pinBoardId;
        }
    }

    file: any;
    image: any = {};
    formData: any = {};
    // REGION image upload
    async processFile(event: any) {
        // this.file = event;
        this.file = event.target.files[0];
        console.log(event);
        if (
            !this.file.name.toLowerCase().includes(".png") &&
            !this.file.name.toLowerCase().includes(".gif") &&
            !this.file.name.toLowerCase().includes(".jpg") &&
            !this.file.name.toLowerCase().includes(".gif")
        ) {
            this.errors.push("Endast jpg, gif, png tillåtna");
        }

        this.formData = new FormData();
        this.formData.append("file", await this.preResizeImage(this.file));

        this.image = URL.createObjectURL(await this.preResizeImage(this.file));

        // has image
        if (this.job.id) {
            await this.addImage(this.job.id);
        }
    }

    async preResizeImage(image: any) {
        const resizedImageBlob = await Utils.resizeImage({
            maxSize: 1400,
            file: this.file,
        });
        const resizedImage = new File(
            [resizedImageBlob as Blob],
            this.file.name.toString().replace(".png", ".jpg"),
            { type: this.file.type }
        );
        return resizedImage;
    }
}
